import {
  IDeviceGroupProps,
  IDeviceGroupSimpleProps,
  IDeviceGroupCreateParams,
  IDeviceGroupUpdateParams,
} from './types';
import { api } from '../DefaultService';

const ENDPOINT = 'v1/devicegroup';

export const createDeviceGroupAsync = async ({
  data,
}: IDeviceGroupCreateParams): Promise<IDeviceGroupProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getDeviceGroupByIdAsync = async (
  id: number,
): Promise<IDeviceGroupProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllDeviceGroupByLicenseAsync = async (): Promise<
  IDeviceGroupSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateDeviceGroupAsync = async ({
  id,
  data,
}: IDeviceGroupUpdateParams): Promise<IDeviceGroupProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteDeviceGroupAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
